import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a7e9f37bedae700140846d0_1787074259135_754e61cf/ecosange/src/app/products/[id]/page.tsx");
